import { WebGetCase, WebSaveCase, ImagesUpload } from '@/api/web'
export default {
  state: {},
  actions: {
    WebGetCase ({ commit }, payload) {
      return new Promise(resolve => {
        WebGetCase(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    WebSaveCase ({ commit }, payload) {
      return new Promise(resolve => {
        WebSaveCase(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    ImagesUpload ({ commit }, payload) {
      return new Promise(resolve => {
        ImagesUpload(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  getters: {},
  mutations: {}
}
